import { Component, OnInit } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { FieldConfig } from "../../../_models/field.interface";
@Component({
  selector: "app-buttonSubmit",
  template: `
<div class="demo-full-width margin-top" [formGroup]="group" [ngStyle]="field.styleDivPrincipal ? field.styleDivPrincipal() : null">
<button type="submit" class="cs_botao {{ field.class }}" [ngStyle]="field.style()" [disabled]="field.disabled">{{field.label}}</button>
</div>
`,
  styles: []
})
export class ButtonSubmitComponent implements OnInit {
  field: FieldConfig;
  group: UntypedFormGroup;
  constructor() {}
  ngOnInit() {}
}